export const DEFAULT_SIZE = 16;
export const DEFAULT_ICON_PADDING = 4;
export const DEFAULT_CHECKED_COLOR = "#e600e5";
export const DEFAULT_UNCHECKED_COLOR = "#B3B5BD";
